import { render, staticRenderFns } from "./MeusPromotoresList.vue?vue&type=template&id=a046e714&scoped=true"
import script from "./MeusPromotoresList.vue?vue&type=script&lang=js"
export * from "./MeusPromotoresList.vue?vue&type=script&lang=js"
import style0 from "./MeusPromotoresList.vue?vue&type=style&index=0&id=a046e714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a046e714",
  null
  
)

export default component.exports